export default __webpack_public_path__ + "static/media/67.69bb0412.png";